import {
  Container,
  Text,
  Textarea,
  Box,
  Flex,
  Spacer,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverHeader,
  PopoverBody,
  PopoverCloseButton,
  ListItem,
  UnorderedList,
} from "@chakra-ui/react";

import { InfoOutlineIcon } from "@chakra-ui/icons";

const QuestionInput = (props) => {
  const { label, placeholder, generatorInput, setGeneratorInput, helperItems } =
    props;

  const handleInputChange = (e) => {
    let inputValue = e.target.value;
    setGeneratorInput(inputValue);
  };

  return (
    <Container mb="10">
      <Box mb="4">
        <Flex>
          <Text fontSize="lg" as="b">
            {label}
          </Text>
          <Spacer />
          {helperItems && (
            <Popover>
              <PopoverTrigger>
                <InfoOutlineIcon m="auto" style={{ cursor: "pointer" }} />
              </PopoverTrigger>
              <PopoverContent
                color="white"
                bg="blue.800"
                borderColor="blue.800"
              >
                <PopoverArrow />
                <PopoverHeader>Tips for Better Results</PopoverHeader>
                <PopoverCloseButton />
                <PopoverBody>
                  <UnorderedList>
                    {helperItems &&
                      helperItems.map((text, index) => (
                        <ListItem key={index}>{text}</ListItem>
                      ))}
                  </UnorderedList>
                </PopoverBody>
              </PopoverContent>
            </Popover>
          )}
        </Flex>
      </Box>
      <Textarea
        size="lg"
        value={generatorInput}
        onChange={handleInputChange}
        placeholder={placeholder}
      />
    </Container>
  );
};

export default QuestionInput;
